// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Dialog from "@reach/dialog";

var $$FileReader = {};

var VisuallyHidden = {};

function Externals$Dialog(props) {
  var __style = props.style;
  var style = __style !== undefined ? __style : ({});
  return React.createElement(Dialog.Dialog, {
              isOpen: props.isOpen,
              onDismiss: props.onDismiss,
              style: style,
              "aria-label": props.ariaLabel,
              children: props.children,
              className: props.className
            });
}

var Dialog$1 = {
  make: Externals$Dialog
};

var Tabs = {};

var TabList = {};

var Tab = {};

var TabPanels = {};

var TabPanel = {};

var ReachTabs = {
  Tabs: Tabs,
  TabList: TabList,
  Tab: Tab,
  TabPanels: TabPanels,
  TabPanel: TabPanel
};

export {
  $$FileReader ,
  VisuallyHidden ,
  Dialog$1 as Dialog,
  ReachTabs ,
}
/* react Not a pure module */
